/**
 * Extracts a user-facing message from a failed API call.
 * Handles the shapes the server returns: a plain string body (e.g. `BadRequest(ex.Message)`),
 * `{ message }` / `{ Message }` objects, and ASP.NET ProblemDetails (`{ title }`).
 * Returns `fallback` when no usable message is present.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as { response?: { data?: unknown } } | null)?.response?.data;

  if (typeof data === "string") {
    const trimmed = data.trim();
    // Ignore HTML error pages and other non-message bodies.
    if (trimmed && !trimmed.startsWith("<")) {
      return trimmed;
    }
    return fallback;
  }

  if (data && typeof data === "object") {
    const body = data as { message?: unknown; Message?: unknown; title?: unknown };
    const message = body.message ?? body.Message ?? body.title;
    if (typeof message === "string" && message.trim()) {
      return message.trim();
    }
  }

  return fallback;
}
